import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RestRoutes } from '../_config/rest-routes.config';
import { HttpClient } from '@angular/common/http';
import { StorageService } from './storage.service';
import { Page } from '../_models/page.model';
import { CacheConstants } from '../_config/cache-constants';
import { JsonPipe } from '@angular/common';
import { NotExpr } from '@angular/compiler';


@Injectable({
  providedIn: 'root',
})
export class PagesService {
  public pagesDownload$ = new Subject<Page[]>();
  public defaultPages: Page[] = []
  //   public pages : Page[] = [
  //     new Page('0','Home','home','fas fa-exclamation-circle'),
  //     new Page('1','login','login','fas fa-lg fa-solid fa-user'),
  //     new Page('2','ClientFileConfiguration','ClientFileConfiguration','fas fa-cog'),
  //     new Page('3','Disputes','disputes','fa-solid fa-table-list'),
  //     new Page('4','Languages','Languages', 'fa-solid fa-list-check'),
  //     new Page('5','fileform','fileform', 'fa-solid fa-file')
  // ];

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  async Pages_Get(): Promise<any> {
    // comprobamos la versión actual de las pages para este usuario
    let urlPagesVersion: string = `${environment.urlPages}${RestRoutes.PAGES}/version`;
    let versionData = await fetch(urlPagesVersion).then((response) =>
      response.json()
    );

    let cacheVersion = this.storageService.get(CacheConstants.PAGES_CACHE_VERSION);
    if (
      cacheVersion != null &&
      versionData['version'] == cacheVersion &&
      this.storageService.get(CacheConstants.PAGES_CACHE_VERSION + '_' + cacheVersion) != null
    ) {
      let pagesList = this.storageService.get(
        CacheConstants.PAGES_CACHE_VERSION + '_' + cacheVersion
      );
      const finalPages = [...this.defaultPages, ...pagesList];
      this.pagesDownload$.next(finalPages);
      return;
    }

    this.storageService.clearPageCache();
    //this.storageService.remove(CacheConstants.PAGES_CACHE_VERSION + '_' + cacheVersion);
    cacheVersion = versionData['version'];

    let urlPages: string = `${environment.urlPages}${RestRoutes.PAGES}?v=${cacheVersion}`;


    this.http.get<Page[]>(urlPages).subscribe(
      {
        next:(pages :Page[]) => {
          this.storageService.set(
            CacheConstants.PAGES_CACHE_VERSION + '_' + cacheVersion,
            pages
          );
          this.storageService.set(CacheConstants.PAGES_CACHE_VERSION, cacheVersion);
          const finalPages = [...this.defaultPages, ...pages];
          this.pagesDownload$.next(finalPages);

        },
        error:(e) => {
          console.error(e);
        },
        complete() {

        },
      }
    );
    return;
  }
}
